// extracted by mini-css-extract-plugin
export default {"buttonOption":"OptionButtonSimple_buttonOption__LDYTO","selected":"OptionButtonSimple_selected__sGUSP"};